import { render, staticRenderFns } from "./GoogleCvDescription.vue?vue&type=template&id=e5fed86a&scoped=true"
import script from "./GoogleCvDescription.vue?vue&type=script&lang=js"
export * from "./GoogleCvDescription.vue?vue&type=script&lang=js"
import style0 from "./GoogleCvDescription.vue?vue&type=style&index=0&id=e5fed86a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5fed86a",
  null
  
)

export default component.exports